import { toast } from "@devhop/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { walletKeys } from "./queries";
import { refundApi } from "./refund-client";

export const refundKeys = {
  all: ["refund"] as const,
  list: (q: Partial<OffsetPageQueryDTO>) => ["refund", "list", q] as const,
};

export function useRefundListQuery(query: Partial<OffsetPageQueryDTO> = {}) {
  const q: OffsetPageQueryDTO = {
    limit: query.limit ?? 20,
    offset: query.offset ?? 0,
    sort: query.sort,
    filters: query.filters,
  };
  return useQuery({
    queryKey: refundKeys.list(q),
    queryFn: () => refundApi.list(q),
  });
}

export function useCreateRefundMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof refundApi.create>[0]) =>
      refundApi.create(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: refundKeys.all });
      qc.invalidateQueries({ queryKey: walletKeys.overview() });
      qc.invalidateQueries({ queryKey: walletKeys.transactions({}) });
      toast.success("ສ້າງຄືນເງິນສຳເລັດ");
    },
    onError: () => {
      toast.error("ສ້າງຄືນເງິນລົ້ມເຫຼວ");
    },
  });
}
